import React from 'react';
import { Form as AntForm } from 'antd';
import classNames from 'classnames';

import { additionsClasses } from '../../../utils';

import styles from './FormGrid.module.scss';

export const Form = ({
  actionComponent,
  fields = [],
  disabled = false,
  additions = [ 'twoCols' ],
  customStyles = {} }) => (
    <div>
      <div
        style={{ ...customStyles }}
        disabled={ disabled }
        className={ classNames(
       styles.form,
       ...additionsClasses(additions, styles)

        ) }
      >
        {fields.map(field => field)}
        {disabled}
      </div>
      <div className={ styles.actionComponent }>
        {actionComponent}
      </div>

    </div>
);

export const FormGrid = AntForm.create({ name: 'search-form' })(Form);
